import {
  VNextButton,
  VNextCard,
  VNextField,
  VNextInput,
} from "@/vnext/primitives";

interface BusinessTypesCreateCardProps {
  isBusy: boolean;
  newLabel: string;
  onCreate: () => void;
  onLabelChange: (value: string) => void;
}

export function BusinessTypesCreateCard({
  isBusy,
  newLabel,
  onCreate,
  onLabelChange,
}: BusinessTypesCreateCardProps) {
  return (
    <VNextCard
      subtitle="Add, rename, archive, or restore the onboarding business types shown to operators and customers."
      title="Add business type"
    >
      <form
        className="business-types-route__create-form"
        onSubmit={(event) => {
          event.preventDefault();
          onCreate();
        }}
      >
        <VNextField
          hint="Labels are trimmed before save and must not be empty."
          label="Business type label"
        >
          <VNextInput
            disabled={isBusy}
            onChange={(event) => onLabelChange(event.target.value)}
            placeholder="e.g. Consulting"
            value={newLabel}
          />
        </VNextField>
        <VNextButton disabled={isBusy} type="submit">
          {isBusy ? "Saving…" : "Add business type"}
        </VNextButton>
      </form>
    </VNextCard>
  );
}
